var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useImage } from 'react-konva-utils';
import { Html } from 'react-konva-utils/es/html';
import { Group, Image, Layer, Rect, Shape, Stage } from 'react-konva';
import classNames from 'classnames';
import { v4 } from 'uuid';
import positionStyles from 'components/position.less';
import Select from 'components/select';
import { outputMsg } from 'store/actioin/action';
import { useSelector } from 'store/hook/useSelector';
// import PNG_1 from '../../../test/testImg/998220226971570176.png';
// import PNG_2 from '../../../test/testImg/998220279522004992.png';
import Styles from './index.less';
/**
 *
 *
 * @export handlePerChange 左上角操作区变动时计算单页映射进stage的scale
 * @param stageInitScale pageItem内Stage自适应宽度后保存的缩放比例 对应左上角操作区域的50 -> 0.5
 * @param perScale 左上角操作区域当前数值
 */
export function handlePerChange(stageInitScale, perScale) {
    return (stageInitScale / 0.5) * perScale;
}
var initCacheRect = { drawing: false, x: 0, y: 0, width: 0, height: 0 };
var defaultWordSelection = {
    show: false,
    showOptionList: false,
    words: '',
    wordsShapeId: [],
    pageNum: null,
    activeShapeId: '',
    field: '',
};
var shapeColor = {
    active: {
        fill: 'rgba(35,134,238, 0.2)',
        stroke: 'rgba(35,134,238, 1.0)',
    },
    normal: {
        fill: 'rgba(35,134,238, 0.04)',
        stroke: 'rgba(35,134,238, 0.2)',
    },
    table: {
        fill: 'yellow',
        stroke: 'green',
    },
};
var PageItem = function (_a) {
    var wordSelection = _a.wordSelection, drawJson = _a.drawJson, listJson = _a.listJson, selectId = _a.selectId, scale = _a.scale, paint = _a.paint, hiddenList = _a.hiddenList, imgData = _a.imgData, handleScroll = _a.handleScroll, responseData = _a.responseData, activeShapes = _a.activeShapes, lastActiveShapes = _a.lastActiveShapes, environment = _a.environment, calcuJson = _a.calcuJson, tableJson = _a.tableJson, llmTableJson = _a.llmTableJson, tableListJson = _a.tableListJson, llmTableListJson = _a.llmTableListJson, extractSeq = _a.extractSeq, llmSeq = _a.llmSeq;
    var keyJson = __spreadArray(__spreadArray([], extractSeq, true), llmSeq.map(function (item) { return (__assign(__assign({}, item), { extractFieldName: item.extractFieldName + '（大模型字段）' })); }), true).reduce(function (acc, cur) {
        acc[cur.extractNum] = cur.extractFieldName;
        return acc;
    }, {});
    var _b = useState({
        width: 0,
        height: 0,
        scale: 1,
        trueScale: 0.5,
    }), imgSelfData = _b[0], setImgSelfData = _b[1];
    var dispatch = useDispatch();
    var model = useSelector(function (state) { return state.global.model; });
    var drawLayerRef = useRef();
    var _c = useState(initCacheRect), cacheRect = _c[0], setcacheRect = _c[1];
    var image = useImage(imgData.imagePath ? imgData.imagePath : "../test/".concat(imgData.imageId, ".png"), 'anonymous')[0];
    // const img_map = {
    //   '998220226971570176': PNG_1,
    //   '998220279522004992': PNG_2,
    // };
    // const [image] = useImage(img_map[imgData.imageId], 'anonymous');
    var oncePageItemRef = useRef(null);
    var canvasBox = useRef(null);
    var stageRef = useRef(null);
    var imageRef = useRef(null);
    useEffect(function () {
        var _a;
        if (image) {
            setImgSelfData(__assign(__assign({}, imgSelfData), { width: image.width, height: image.height, scale: ((_a = canvasBox.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) / image.width }));
        }
    }, [image]);
    useEffect(function () {
        var _a;
        if (image) {
            setImgSelfData(__assign(__assign({}, imgSelfData), { width: image.width, height: image.height, scale: ((_a = canvasBox.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) / image.width, trueScale: 0.5 }));
        }
    }, [hiddenList]);
    useEffect(function () {
        setImgSelfData(__assign(__assign({}, imgSelfData), { trueScale: scale }));
    }, [scale]);
    useEffect(function () {
        if (responseData && responseData.pageNum === imgData.pageNum) {
            if (wordSelection.wordsShapeId.some(function (item) { return item === responseData.shapeId; })) {
                dispatch({
                    type: 'setWordSelection',
                    payload: __assign(__assign({}, wordSelection), { words: wordSelection.words +
                            JSON.parse(responseData.responseData).ocrResult }),
                });
            }
            dispatch({
                type: 'setDrawJson',
                payload: drawJson.map(function (item) {
                    if (item.shapeId === responseData.shapeId) {
                        return __assign(__assign({}, item), { words: JSON.parse(responseData.responseData).ocrResult });
                    }
                    else {
                        return item;
                    }
                }),
            });
        }
    }, [responseData]);
    useEffect(function () {
        if (activeShapes.length > 0 &&
            activeShapes[0].pageNum === imgData.pageNum) {
            var shapes = activeShapes.map(function (item) { var _a; return (_a = stageRef.current) === null || _a === void 0 ? void 0 : _a.find("#".concat(item.shapeId))[0]; });
            shapesShining(shapes);
            var shapeLT = { x: 0, y: 0 };
            if (activeShapes[0].type === 'calcuJson') {
                shapeLT = {
                    x: calcuJson.find(function (item) { return item.shapeId === activeShapes[0].shapeId; })
                        .wordsLocation.leftTop.x,
                    y: calcuJson.find(function (item) { return item.shapeId === activeShapes[0].shapeId; })
                        .wordsLocation.leftTop.y,
                };
            }
            else {
                shapeLT = {
                    x: drawJson.find(function (item) { return item.shapeId === activeShapes[0].shapeId; }).x,
                    y: drawJson.find(function (item) { return item.shapeId === activeShapes[0].shapeId; }).y,
                };
            }
            var proportion = {
                x: shapeLT.x / imgSelfData.width,
                y: shapeLT.y / imgSelfData.height,
            };
            var boxMapping = {
                x: oncePageItemRef.current.offsetWidth * proportion.x,
                y: oncePageItemRef.current.offsetHeight * proportion.y,
            };
            handleScroll(boxMapping.x + canvasBox.current.offsetLeft, boxMapping.y + canvasBox.current.offsetTop);
        }
        else if (activeShapes.filter(function (item) { return item.pageNum === imgData.pageNum; }).length > 0) {
            var shapes = activeShapes.map(function (item) { var _a; return (_a = stageRef.current) === null || _a === void 0 ? void 0 : _a.find("#".concat(item.shapeId))[0]; });
            shapesShining(shapes);
        }
    }, [activeShapes]);
    useEffect(function () {
        if (lastActiveShapes.filter(function (shape) { return shape.pageNum === imgData.pageNum; })
            .length > 0) {
            var shapes = lastActiveShapes.map(function (item) { var _a; return (_a = stageRef.current) === null || _a === void 0 ? void 0 : _a.find("#".concat(item.shapeId))[0]; });
            shapes.forEach(function (shape) {
                shape &&
                    shape.to(__assign(__assign({}, shapeColor.normal), { duration: 1.2 }));
            });
        }
    }, [lastActiveShapes]);
    var shapesShining = function (shapes) {
        shapes.forEach(function (shape) {
            if (shape) {
                shape &&
                    shape.to(__assign(__assign({ duration: 0.2 }, shapeColor.normal), { onFinish: function () {
                            shape &&
                                shape.to(__assign(__assign({}, shapeColor.active), { duration: 0.2, onFinish: function () {
                                        shape &&
                                            shape.to(__assign(__assign({}, shapeColor.normal), { duration: 0.2, onFinish: function () {
                                                    shape &&
                                                        shape.to(__assign(__assign({}, shapeColor.active), { duration: 0.2 }));
                                                } }));
                                    } }));
                        } }));
            }
        });
    };
    var calcuModalPosition = function (attrs, boxWidth, boxHeight, boxTop, boxLeft) {
        // attrs:框选单位属性
        // boxHeight:可视区域高度
        // boxWidth:可视区域宽度
        var scrollTop = document.getElementById('scrollBody').scrollTop;
        var scrollLeft = document.getElementById('scrollBody').scrollLeft;
        var bodyHeight = document.getElementById('scrollBody').clientHeight;
        var bodyWidth = document.getElementById('scrollBody').clientWidth;
        var moveBox = {
            top: scrollTop - boxTop,
            height: bodyHeight,
            left: scrollLeft - boxLeft,
            width: bodyWidth,
        };
        var modalWidth = 300;
        var modalHeight = 200;
        var x = attrs.width < 0
            ? (attrs.x + attrs.width) *
                handlePerChange(imgSelfData.scale, imgSelfData.trueScale)
            : attrs.x * handlePerChange(imgSelfData.scale, imgSelfData.trueScale);
        var y = attrs.height < 0
            ? (attrs.y + attrs.height) *
                handlePerChange(imgSelfData.scale, imgSelfData.trueScale)
            : attrs.y * handlePerChange(imgSelfData.scale, imgSelfData.trueScale);
        var width = Math.abs(attrs.width) *
            handlePerChange(imgSelfData.scale, imgSelfData.trueScale);
        var height = Math.abs(attrs.height) *
            handlePerChange(imgSelfData.scale, imgSelfData.trueScale);
        if (x + width + modalWidth <= moveBox.left + moveBox.width) {
            if (y + modalHeight <= moveBox.top + moveBox.height) {
                return {
                    x: x + width + 10,
                    y: y,
                };
            }
            else {
                return {
                    x: x + width + 10,
                    y: moveBox.top + moveBox.height - modalHeight,
                };
            }
        }
        else {
            if (y + modalHeight <= moveBox.top + moveBox.height) {
                return {
                    x: moveBox.left + moveBox.width - modalWidth,
                    y: y + height + 10,
                };
            }
            else {
                if (x - modalWidth - 10 < 0) {
                    return {
                        x: 10,
                        y: moveBox.top + moveBox.height - modalHeight,
                    };
                }
                else {
                    return {
                        x: x - modalWidth - 10,
                        y: moveBox.top + moveBox.height - modalHeight,
                    };
                }
            }
        }
    };
    var getFillAndStroke = function (extractId, shapeId) {
        if (extractId === selectId ||
            wordSelection.wordsShapeId.some(function (item) { return item === shapeId; })) {
            return shapeColor.active;
        }
        else {
            return shapeColor.normal;
        }
    };
    var renderStage = function () {
        if (image) {
            return (React.createElement(Stage, { ref: stageRef, onMouseDown: function (e) {
                    if (paint) {
                        if (e.evt.buttons === 1) {
                            setcacheRect(__assign(__assign({}, cacheRect), { x: e.evt.offsetX /
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale), y: e.evt.offsetY /
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale), drawing: true }));
                        }
                    }
                }, onMouseUp: function (e) {
                    if (paint) {
                        if (Math.abs(cacheRect.width *
                            handlePerChange(imgSelfData.scale, imgSelfData.trueScale)) > 10 ||
                            Math.abs(cacheRect.height *
                                handlePerChange(imgSelfData.scale, imgSelfData.trueScale)) > 10) {
                            var shapeId_1 = v4();
                            dispatch({
                                type: 'setDrawJson',
                                payload: drawJson.concat(__assign(__assign({}, cacheRect), { pageNum: imgData.pageNum, shapeId: shapeId_1, words: '' })),
                            });
                            dispatch({
                                type: 'setWordSelection',
                                payload: __assign(__assign({}, wordSelection), { show: true, activeShapeId: shapeId_1, pageNum: imgData.pageNum, wordsShapeId: wordSelection.wordsShapeId.concat(shapeId_1) }),
                            });
                            imageRef.current.toDataURL({
                                x: cacheRect.width > 0
                                    ? cacheRect.x *
                                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale)
                                    : (cacheRect.x + cacheRect.width) *
                                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                                y: cacheRect.height > 0
                                    ? cacheRect.y *
                                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale)
                                    : (cacheRect.y + cacheRect.height) *
                                        handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                                width: Math.abs(cacheRect.width *
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale)),
                                height: Math.abs(cacheRect.height *
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale)),
                                callback: function (str) {
                                    // dispatch({
                                    //     type: "frameSelectionUnit",
                                    //     payload: {
                                    //         pageNum: imgData.pageNum,
                                    //     },
                                    // })
                                    model.invokeAsync('recognize', {
                                        requestData: str,
                                        shapeId: shapeId_1,
                                        responseData: '',
                                        pageNum: imgData.pageNum,
                                    });
                                },
                            });
                            setcacheRect(initCacheRect);
                        }
                        else {
                            setcacheRect(initCacheRect);
                        }
                    }
                }, onMouseMove: function (e) {
                    if (paint) {
                        if (cacheRect.drawing && e.evt.buttons === 1) {
                            setcacheRect(__assign(__assign({}, cacheRect), { width: e.evt.offsetX /
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale) -
                                    cacheRect.x, height: e.evt.offsetY /
                                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale) -
                                    cacheRect.y }));
                        }
                        else {
                            setcacheRect(initCacheRect);
                        }
                    }
                }, width: imgSelfData.width *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale), height: imgSelfData.height *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale), scaleX: handlePerChange(imgSelfData.scale, imgSelfData.trueScale), scaleY: handlePerChange(imgSelfData.scale, imgSelfData.trueScale), className: Styles.onceCanvasBox },
                renderImageLayer(),
                renderDrawLayer()));
        }
        else {
            return null;
        }
    };
    // hitGraphEnabled 点击是否能命中
    var renderImageLayer = function () {
        var handleContinue = function () {
            dispatch({
                type: 'setWordSelection',
                payload: __assign(__assign({}, wordSelection), { show: false }),
            });
        };
        var handleCancel = function () {
            var delUnit = drawJson;
            wordSelection.wordsShapeId.forEach(function (item) {
                delUnit = delUnit.filter(function (rect) { return rect.shapeId !== item; });
            });
            dispatch({
                type: 'setWordSelection',
                payload: defaultWordSelection,
            });
            dispatch({
                type: 'setDrawJson',
                payload: delUnit,
            });
        };
        var handleOk = function () {
            if (wordSelection.type === 'normal') {
                if (wordSelection.field !== '' && wordSelection.words !== '') {
                    var extractId_1 = v4();
                    var drawBindListJsonData = {
                        extractId: extractId_1,
                        key: wordSelection.field,
                        type: 'drawJson',
                        value: wordSelection.words,
                        data: wordSelection.wordsShapeId.map(function (item) {
                            return __assign(__assign({}, drawJson.find(function (rect) { return rect.shapeId === item; })), { extractId: extractId_1 });
                        }),
                        confidence: null,
                    };
                    dispatch({
                        type: 'saveDrawBindListJson',
                        payload: drawBindListJsonData,
                    });
                    dispatch({
                        type: 'setWordSelection',
                        payload: defaultWordSelection,
                    });
                    dispatch({
                        type: 'responseData',
                        payload: null,
                    });
                }
                else if (wordSelection.field === '') {
                    dispatch(outputMsg('未选择对应字段'));
                    console.error('未选择对应字段');
                }
                else if (wordSelection.words === '') {
                    dispatch(outputMsg('识别结果字段不得为空'));
                    console.error('识别结果字段不得为空');
                }
            }
            if (wordSelection.type === 'table') {
                if (wordSelection.tableSelected &&
                    wordSelection.tableSelected.tableId !== '' &&
                    wordSelection.tableSelected.lineKey !== '' &&
                    wordSelection.words !== '') {
                    var extractId_2 = v4();
                    var tableSelected = wordSelection.tableSelected;
                    var drawBindTableListJsonData = {
                        extractId: extractId_2,
                        key: tableSelected.lineKey,
                        type: 'drawJson',
                        value: wordSelection.words,
                        confidence: null,
                        data: wordSelection.wordsShapeId.map(function (item) {
                            return __assign(__assign({}, drawJson.find(function (rect) { return rect.shapeId === item; })), { extractId: extractId_2 });
                        }),
                    };
                    var cloneTable = JSON.parse(JSON.stringify(tableListJson));
                    var lastDrawDataId = 'noData';
                    var line_1 = cloneTable[tableSelected.tableKey].tableData[tableSelected.lineIndex].tableLineData[tableSelected.lineKey];
                    if (line_1.drawData.length > 0) {
                        lastDrawDataId = line_1.drawData[0].extractId;
                    }
                    if (line_1.selectType === 'tableJson') {
                        var newTableJson = tableJson.map(function (item) {
                            if (item.extractId === line_1.select) {
                                return __assign(__assign({}, item), { hidden: true });
                            }
                            else {
                                return item;
                            }
                        });
                        dispatch({
                            type: 'hiddenTableUnit',
                            payload: newTableJson,
                        });
                    }
                    line_1.drawData = drawBindTableListJsonData.data;
                    line_1.select = drawBindTableListJsonData.data[0].extractId;
                    line_1.selectType = drawBindTableListJsonData.type;
                    line_1.value = drawBindTableListJsonData.value;
                    line_1.confidence = drawBindTableListJsonData.confidence;
                    dispatch({
                        type: 'saveDrawBindTableListJson',
                        payload: {
                            cloneTable: cloneTable,
                            lastDrawDataId: lastDrawDataId,
                            drawData: drawBindTableListJsonData.data,
                        },
                    });
                    dispatch({
                        type: 'setWordSelection',
                        payload: defaultWordSelection,
                    });
                    dispatch({
                        type: 'responseData',
                        payload: null,
                    });
                }
                else if (wordSelection.tableSelected.tableId === '') {
                    dispatch(outputMsg('未选择表格字段'));
                    console.error('未选择表格字段');
                }
                else if (wordSelection.words === '') {
                    dispatch(outputMsg('识别结果字段不得为空'));
                    console.error('识别结果字段不得为空');
                }
            }
            if (wordSelection.type === 'llmTable') {
                if (wordSelection.tableSelected &&
                    wordSelection.tableSelected.tableId !== '' &&
                    wordSelection.tableSelected.lineKey !== '' &&
                    wordSelection.words !== '') {
                    var extractId_3 = v4();
                    var tableSelected = wordSelection.tableSelected;
                    var drawBindTableListJsonData = {
                        extractId: extractId_3,
                        key: tableSelected.lineKey,
                        type: 'drawJson',
                        value: wordSelection.words,
                        confidence: null,
                        data: wordSelection.wordsShapeId.map(function (item) {
                            return __assign(__assign({}, drawJson.find(function (rect) { return rect.shapeId === item; })), { extractId: extractId_3 });
                        }),
                    };
                    var cloneLlmTable = JSON.parse(JSON.stringify(llmTableListJson));
                    var lastDrawDataId = 'noData';
                    var line_2 = cloneLlmTable[tableSelected.tableKey].tableData[tableSelected.lineIndex].tableLineData[tableSelected.lineKey];
                    if (line_2.drawData.length > 0) {
                        lastDrawDataId = line_2.drawData[0].extractId;
                    }
                    if (line_2.selectType === 'tableJson') {
                        var newLlmTableJson = llmTableJson.map(function (item) {
                            if (item.extractId === line_2.select) {
                                return __assign(__assign({}, item), { hidden: true });
                            }
                            else {
                                return item;
                            }
                        });
                        dispatch({
                            type: 'hiddenLlmTableUnit',
                            payload: newLlmTableJson,
                        });
                    }
                    line_2.drawData = drawBindTableListJsonData.data;
                    line_2.select = drawBindTableListJsonData.data[0].extractId;
                    line_2.selectType = drawBindTableListJsonData.type;
                    line_2.value = drawBindTableListJsonData.value;
                    line_2.confidence = drawBindTableListJsonData.confidence;
                    dispatch({
                        type: 'saveDrawBindLlmTableListJson',
                        payload: {
                            cloneLlmTable: cloneLlmTable,
                            lastDrawDataId: lastDrawDataId,
                            drawData: drawBindTableListJsonData.data,
                        },
                    });
                    dispatch({
                        type: 'setWordSelection',
                        payload: defaultWordSelection,
                    });
                    dispatch({
                        type: 'responseData',
                        payload: null,
                    });
                }
                else if (wordSelection.tableSelected.tableId === '') {
                    dispatch(outputMsg('未选择表格字段'));
                    console.error('未选择表格字段');
                }
                else if (wordSelection.words === '') {
                    dispatch(outputMsg('识别结果字段不得为空'));
                    console.error('识别结果字段不得为空');
                }
            }
        };
        var generratetableList = function () {
            var tableSeq = extractSeq.filter(function (seq) { return seq.tableFlag; });
            var tableMap = new Map();
            tableSeq.forEach(function (seq) {
                if (tableMap.has(seq.tableNum)) {
                    tableMap.set(seq.tableNum, tableMap.get(seq.tableNum).concat(seq));
                }
                else {
                    tableMap.set(seq.tableNum, [seq]);
                }
            });
            var tableArr = Array.from(tableMap);
            var tableSelectedList = tableArr.map(function (table) {
                var tableKey = table[0];
                var tableData = table[1];
                var tableId = tableListJson[tableKey].tableId;
                return tableData.map(function (line, index) {
                    var lineKey = line.extractNum;
                    var lineName = line.extractFieldName;
                    var lineDepth = tableListJson[tableKey].tableData.length;
                    return {
                        tableKey: tableKey,
                        tableId: tableId,
                        lineKey: lineKey,
                        lineName: lineName,
                        lineDepth: lineDepth,
                        index: index,
                    };
                });
            });
            return tableSelectedList.reduce(function (a, b) { return a.concat(b); }, []);
        };
        var generrateLlmTableList = function () {
            var llmTableSeq = llmSeq.filter(function (seq) { return seq.tableFlag; });
            var llmTableMap = new Map();
            llmTableSeq.forEach(function (seq) {
                if (llmTableMap.has(seq.tableNum)) {
                    llmTableMap.set(seq.tableNum, llmTableMap.get(seq.tableNum).concat(seq));
                }
                else {
                    llmTableMap.set(seq.tableNum, [seq]);
                }
            });
            var llmTableArr = Array.from(llmTableMap);
            var llmTableSelectedList = llmTableArr.map(function (table) {
                var tableKey = table[0];
                var tableData = table[1];
                var tableId = llmTableListJson[tableKey].tableId;
                return tableData.map(function (line, index) {
                    var lineKey = line.extractNum;
                    var lineName = line.extractFieldName + '（大模型字段）';
                    var lineDepth = llmTableListJson[tableKey].tableData.length;
                    return {
                        tableKey: tableKey,
                        tableId: tableId,
                        lineKey: lineKey,
                        lineName: lineName,
                        lineDepth: lineDepth,
                        index: index,
                        isLlm: true,
                    };
                });
            });
            return llmTableSelectedList.reduce(function (a, b) { return a.concat(b); }, []);
        };
        var renderHtml = function () {
            var _a;
            if (wordSelection.show && wordSelection.pageNum === imgData.pageNum) {
                var activeShape = (_a = stageRef.current) === null || _a === void 0 ? void 0 : _a.find(".".concat(wordSelection.activeShapeId));
                if (activeShape.length !== 0) {
                    var positioin = calcuModalPosition(activeShape[0].getAttrs(), canvasBox.current.clientWidth, canvasBox.current.clientHeight, canvasBox.current.offsetTop, canvasBox.current.offsetLeft);
                    return (React.createElement(Html, { divProps: {
                            style: {
                                zIndex: 10000,
                                transform: "translate(".concat(positioin.x, "px, ").concat(positioin.y, "px) rotate(0deg) scaleX(1.0) scaleY(1.0)"),
                            },
                        } },
                        React.createElement("div", { className: Styles.addWords },
                            React.createElement("div", { className: classNames(Styles.addWordsBody, positionStyles['around_center']) },
                                React.createElement("div", { className: classNames(Styles.addWordsNormalLine, positionStyles['column_center_start']) },
                                    React.createElement("div", { className: Styles.title }, "\u8BC6\u522B\u7ED3\u679C"),
                                    React.createElement("input", { type: 'text', className: Styles.addWordsInput, onChange: function (e) {
                                            dispatch({
                                                type: 'setWordSelection',
                                                payload: __assign(__assign({}, wordSelection), { words: e.target.value }),
                                            });
                                        }, value: wordSelection.words })),
                                React.createElement("div", { className: classNames(Styles.addWordsNormalLine, positionStyles['column_center_start']) },
                                    React.createElement("div", { className: Styles.title },
                                        React.createElement("span", null, "\u5BF9\u5E94\u5B57\u6BB5")),
                                    React.createElement("div", { className: classNames(Styles.addWordsSwitch, positionStyles['around_center']) },
                                        React.createElement(Select, { list: listJson.filter(function (item) {
                                                return extractSeq
                                                    .concat(llmSeq)
                                                    .some(function (seq) { return seq.extractNum === item.key; });
                                            }), tableList: generratetableList().concat(generrateLlmTableList()), keyJson: keyJson, selected: wordSelection.field, selectedTable: wordSelection.tableSelected, cb: function (item, type) {
                                                if (type === 'normal') {
                                                    dispatch({
                                                        type: 'setWordSelection',
                                                        payload: __assign(__assign({}, wordSelection), { type: 'normal', field: item.key, showOptionList: false }),
                                                    });
                                                }
                                                if (type === 'table') {
                                                    dispatch({
                                                        type: 'setWordSelection',
                                                        payload: __assign(__assign({}, wordSelection), { type: 'table', tableSelected: {
                                                                tableKey: item.data[0].tableKey,
                                                                tableId: item.data[0].tableId,
                                                                lineKey: item.data[0].lineKey,
                                                                lineName: item.data[0].lineName,
                                                                lineIndex: item.index,
                                                            }, showOptionList: false }),
                                                    });
                                                }
                                                if (type === 'llmTable') {
                                                    dispatch({
                                                        type: 'setWordSelection',
                                                        payload: __assign(__assign({}, wordSelection), { type: 'llmTable', tableSelected: {
                                                                tableKey: item.data[0].tableKey,
                                                                tableId: item.data[0].tableId,
                                                                lineKey: item.data[0].lineKey,
                                                                lineName: item.data[0].lineName,
                                                                lineIndex: item.index,
                                                            }, showOptionList: false }),
                                                    });
                                                }
                                            } })))),
                            React.createElement("div", { className: classNames(Styles.addWordsFooter, positionStyles['around_center']) },
                                React.createElement("span", { className: Styles.continueSelection, onClick: function () { return handleContinue(); } }, "\u7EE7\u7EED\u6846\u9009"),
                                React.createElement("div", { className: Styles.selectionBtnArea },
                                    React.createElement("button", { className: Styles.selectionCancel, onClick: function () { return handleCancel(); } }, "\u53D6\u6D88"),
                                    React.createElement("button", { className: Styles.selectionOk, onClick: function () { return handleOk(); } }, "\u786E\u8BA4"))))));
                }
            }
        };
        return (React.createElement(Layer, null,
            renderImg,
            renderHtml(),
            cacheRect ? (React.createElement(Rect, { key: 'cacheRect', x: cacheRect.x, y: cacheRect.y, width: cacheRect.width, height: cacheRect.height, fill: 'rgba(35,134,238, 0.2)', stroke: 'rgba(35,134,238, 1.0)', strokeWidth: 3 })) : null));
    };
    var classify = function (shapeList) {
        var newShapeList = [];
        var delShapelist = shapeList.concat();
        shapeList.forEach(function (item) {
            newShapeList.push(delShapelist.filter(function (shape) { return shape.extractId === item.extractId; }));
            delShapelist = delShapelist.filter(function (shape) { return shape.extractId !== item.extractId; });
        });
        newShapeList = newShapeList.filter(function (item) { return item.length > 0; });
        return newShapeList;
    };
    var renderRect = function () {
        var usefulDotLineRects = classify(calcuJson.filter(function (calcuItem) {
            return listJson
                .filter(function (item) { return extractSeq.some(function (seq) { return seq.extractNum === item.key; }); })
                .some(function (listItem) { return listItem.select === calcuItem.extractId; });
        }));
        var usefulNormalRect = classify(drawJson.filter(function (item) { return item.pageNum === imgData.pageNum; }));
        var usefulRect = usefulDotLineRects.concat(usefulNormalRect);
        return usefulRect.map(function (shapeList) {
            return (React.createElement(GroupShape, { key: shapeList.reduce(function (a, b) { return a + b.extractId; }, ''), shapeList: shapeList, paint: paint, getFillAndStroke: getFillAndStroke }));
        });
    };
    // const renderDrawRect = () => {
    //     const usefulNormalRects = classify(
    //         drawJson.filter((calcuItem) =>
    //             listJson
    //                 .filter((item) => extractSeq.some((seq) => seq.extractNum === item.key))
    //                 .some((listItem) => listItem.select === calcuItem.extractId)
    //         )
    //     )
    //     const usefulNormalRect = classify(drawJson.filter((item) => item.pageNum === imgData.pageNum))
    //     const usefulRect = usefulDotLineRects.concat(usefulNormalRect)
    //     return usefulRect.map((shapeList) => {
    //         return (
    //             <GroupShape
    //                 key={shapeList.reduce((a, b) => a + b.extractId, "")}
    //                 shapeList={shapeList}
    //                 paint={paint}
    //                 getFillAndStroke={getFillAndStroke}
    //             />
    //         )
    //     })
    // }
    var renderTableRect = function () {
        var usefulTableKeys = extractSeq
            .filter(function (seq) { return seq.tableFlag; })
            .map(function (data) {
            return {
                tableName: data.tableName,
                tableNum: data.tableNum,
                extractNum: data.extractNum,
                extractFieldName: data.extractFieldName,
            };
        });
        var usefulTable = classify(tableJson.filter(function (item) {
            return (item.pageNum === imgData.pageNum &&
                usefulTableKeys.some(function (key) { return item.key === key.extractNum; }) &&
                !item.hidden);
        }));
        return usefulTable.map(function (shapeList) {
            return (React.createElement(GroupShape, { key: shapeList.reduce(function (a, b) { return a + b.extractId; }, ''), shapeList: shapeList, paint: paint, getFillAndStroke: getFillAndStroke }));
        });
    };
    var renderDrawLayer = function () {
        return (React.createElement(Layer, { ref: drawLayerRef, listening: !paint },
            renderRect(),
            renderTableRect()));
    };
    var renderImg = environment === 'online' ? (React.createElement(Image, { ref: imageRef, x: 0, y: 0, width: imgSelfData.width, height: imgSelfData.height, image: image })) : (React.createElement(Image, { ref: imageRef, x: 0, y: 0, width: imgSelfData.width, height: imgSelfData.height, image: null }));
    var renderHtml = function () {
        return (React.createElement(Html, { divProps: {
                style: {
                    position: 'absolute',
                    zIndex: -1,
                },
            } }, React.createElement("img", { className: Styles.backgroundImg, src: imgData.imgSrc })));
    };
    return (React.createElement("div", { ref: canvasBox, style: { cursor: paint ? 'crosshair' : null }, className: Styles.canvasOutBox },
        React.createElement("div", { style: {
                width: imgSelfData.width *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
                height: imgSelfData.height *
                    handlePerChange(imgSelfData.scale, imgSelfData.trueScale),
            }, ref: oncePageItemRef, className: Styles.oncePage }, renderStage())));
};
export var GroupShape = function (_a) {
    var shapeList = _a.shapeList, paint = _a.paint, getFillAndStroke = _a.getFillAndStroke;
    var getRect = function (shapeData) {
        if (shapeData.type === 'calcuJson' || shapeData.type === 'tableJson') {
            return (React.createElement(DotLineRect, { key: shapeData.shapeId, shapeData: shapeData, paint: paint, getFillAndStroke: getFillAndStroke }));
        }
        else {
            return (React.createElement(NormalRect, { key: shapeData.shapeId, shapeData: shapeData, paint: paint, getFillAndStroke: getFillAndStroke }));
        }
        // else if (shapeData.type === "tableJson") {
        //     return (
        //         <DotLineRect
        //             key={shapeData.shapeId}
        //             shapeData={shapeData}
        //             paint={paint}
        //             getFillAndStroke={getFillAndStroke}
        //         />
        //     )
        // }
    };
    return (React.createElement(Group, { name: shapeList[0].extractId, id: shapeList[0].extractId, key: shapeList[0].extractId }, shapeList.map(function (shapeData) {
        return getRect(shapeData);
    })));
};
export var NormalRect = function (_a) {
    var shapeData = _a.shapeData, paint = _a.paint, getFillAndStroke = _a.getFillAndStroke;
    var dispatch = useDispatch();
    return (React.createElement(Rect, { key: shapeData.shapeId, id: shapeData.shapeId, name: shapeData.shapeId, x: shapeData.x, y: shapeData.y, onMouseMove: function () {
            if (!paint) {
                dispatch({ type: 'changeSelectId', payload: shapeData.extractId });
            }
        }, onClick: function () {
            if (!paint) {
                dispatch({ type: 'clickShape', payload: shapeData.extractId });
            }
        }, onMouseLeave: function () {
            if (!paint) {
                dispatch({ type: 'changeSelectId', payload: null });
            }
        }, width: shapeData.width, height: shapeData.height, fill: getFillAndStroke(shapeData.extractId, shapeData.shapeId).fill, stroke: getFillAndStroke(shapeData.extractId, shapeData.shapeId).stroke, strokeWidth: 3 }));
};
export var DotLineRect = function (_a) {
    var shapeData = _a.shapeData, paint = _a.paint, getFillAndStroke = _a.getFillAndStroke;
    var dispatch = useDispatch();
    var lineShape = function (context, shape) {
        context.beginPath();
        context.moveTo(shapeData.wordsLocation.leftBottom.x, shapeData.wordsLocation.leftBottom.y);
        context.lineTo(shapeData.wordsLocation.leftTop.x, shapeData.wordsLocation.leftTop.y);
        context.lineTo(shapeData.wordsLocation.rightTop.x, shapeData.wordsLocation.rightTop.y);
        context.lineTo(shapeData.wordsLocation.rightBottom.x, shapeData.wordsLocation.rightBottom.y);
        context.lineTo(shapeData.wordsLocation.leftBottom.x, shapeData.wordsLocation.leftBottom.y);
        context.closePath();
        context.fillStrokeShape(shape);
    };
    return (React.createElement(Shape, { name: shapeData.shapeId, id: shapeData.shapeId, x: 0, y: 0, onMouseMove: function () {
            if (!paint) {
                dispatch({ type: 'changeSelectId', payload: shapeData.extractId });
            }
        }, onClick: function () {
            if (!paint) {
                dispatch({ type: 'clickShape', payload: shapeData.extractId });
            }
        }, onMouseLeave: function () {
            if (!paint) {
                dispatch({ type: 'changeSelectId', payload: null });
            }
        }, fill: getFillAndStroke(shapeData.extractId, shapeData.shapeId).fill, stroke: getFillAndStroke(shapeData.extractId, shapeData.shapeId).stroke, strokeWidth: 3, key: shapeData.shapeId, sceneFunc: lineShape }));
};
export default PageItem;
